export default __webpack_public_path__ + "static/media/btn-stage2-pressed.0d4d9605.png";